import { ChevronLeftIcon } from 'assets/icons/v2';
import { NovaIconButton } from 'components/ui/NovaIconButton';
import { ReactElement } from 'react';
import { useNavigate } from 'react-router-dom';

type BackButtonProps = {
  alternativeFunc?: () => void;
  color?: string;
};

export const BackButton = ({ alternativeFunc, color }: BackButtonProps): ReactElement => {
  const navigate = useNavigate();
  return (
    <NovaIconButton
      aria-label="Zurück"
      variant="primary"
      size="l"
      verticalAlign="middle"
      color="text.onAccent"
      px="0"
      ml="0"
      _hover={{
        background: 'transparent',
      }}
      onClick={() => (alternativeFunc ? alternativeFunc() : navigate(-1))}
      _focus={{ outline: 'none' }}
      _focusVisible={{ outline: 'none' }}
      icon={ChevronLeftIcon}
      iconProps={color !== undefined ? { color } : undefined}
    />
  );
};
